import { render, staticRenderFns } from "./TableTxItems.vue?vue&type=template&id=2be8fca8&"
import script from "./TableTxItems.vue?vue&type=script&lang=js&"
export * from "./TableTxItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports